export enum AuthErrorTypes {
  AUTHORIZATION_FAILURE = 'AUTHORIZATION_FAILURE',
  SIM_NOT_FOUND = 'SIM_NOT_FOUND',
  SIM_NOT_ALLOWED = 'SIM_NOT_ALLOWED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}
